import React from "react";

type Props = {
  arrowBottomClickHandler: () => void;
  arrowTopClickHandler: () => void;
};

const TableHeaderArrows = ({ arrowBottomClickHandler, arrowTopClickHandler }: Props) => {
  return (
    <div>
      <div
        style={{
          borderLeft: "4px solid transparent",
          borderRight: "4px solid transparent",
          borderBottom: "4px solid var(--app-border-strong)",
          marginBottom: "4px",
          cursor: "pointer",
        }}
        onClick={arrowTopClickHandler}
      />
      <div
        style={{
          borderLeft: "4px solid transparent",
          borderRight: "4px solid transparent",
          borderTop: "4px solid var(--app-border-strong)",
          cursor: "pointer",
        }}
        onClick={arrowBottomClickHandler}
      />
    </div>
  );
};

export default TableHeaderArrows;
